/*
 * @Author: Ximen
 * @Date: 2021-03-18 15:57:31
 * @LastEditors: Ximen
 * @LastEditTime: 2021-04-15 18:49:58
 */
import Http from '@/untils/http';

import getParams from './params';

interface ParamsType {
  accountId?: string;
  memberId?: string;
}

class Service extends Http {
  // // eslint-disable-next-line no-useless-constructor
  // constructor() {
  //   // 调用实现父类的构造函数
  //   super();
  // }

  /**
   * 获取数据方法
   * @param {String} url - 请求url
   * @param {Object} params - 需要拼接的参数
   */
  get = (url = '', param: object, isUploadImg = false) => {
    const params = getParams(param);
    return this.request(url, 'GET', params, null, isUploadImg);
  }

  /**
   * 获取数据方法
   * @param {String} url - 请求url
   * @param {Object} params - 需要拼接的参数
   * @param {Object} data - 放在request payLoad 的参数
   */
  post = (url: string, param: object, data = null, isUploadImg = false) => {
    const params = getParams(param || null, false, true);
    return this.request(
      url,
      'POST',
      params,
      data
        ? Object.assign(data, {
          accountId: params.accountId,
          memberId: params.memberId,
        })
        : null,
      isUploadImg,
    );
  }

  // 未登陆状态接口调用
  noLogin = (url: string, param: object) => {
    const params: ParamsType = getParams(param, true);
    return this.request(url, 'GET', params, null);
  }

  /**
   * 获取数据方法
   * @param {String} url - 请求url
   * @param {Boolean} isMenu - 是否请请求菜单 默认 true
   * @param {Boolean} _allow_anonymous - 是否刷新 默认 true
   */
  getJson = (url: string, allowAnonymous = true) => this.requestJson(url, allowAnonymous)
}
const service = new Service();
export default service;
